import React from 'react';
import classNames from 'classnames';

import s from './styles.module.scss';

interface IProps {
  term: React.ReactNode;
  description: React.ReactNode;
  className?: string;
  termClassName?: string;
  descriptionClassName?: string;
}

const BaseDescriptionItem: React.FC<IProps> = ({
  term,
  description,
  className,
  termClassName,
  descriptionClassName,
}) => {
  return (
    <div className={classNames(s.item, className)}>
      <dt className={classNames(s.dt, termClassName)}>{term}:</dt>
      <dd className={classNames(s.dd, descriptionClassName)}>{description}</dd>
    </div>
  );
};

export default BaseDescriptionItem;
